import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { PILLARS } from "@/data/content";

export const Process = () => (
    <Chapter id="process" number="01" label="How We Work" title="A Curated, Collaborative Process" testid="manifesto-chapter-07">
        <Reveal delay={0.15} className="max-w-2xl text-base font-light leading-relaxed text-mute sm:text-lg">
            <p>
                Every project begins with conversation. A meaningful home is not assembled—it is shaped
                with care, refined through detail, and brought to life through craftsmanship.
            </p>
        </Reveal>
        <div className="mt-12 border-t border-wood/10">
            {PILLARS.map((p, i) => (
                <Reveal key={p.number} delay={0.06 * i}>
                    <div className="group grid grid-cols-1 gap-4 border-b border-wood/10 py-8 transition-colors duration-500 hover:bg-sand md:grid-cols-12 md:gap-8 md:px-6 lg:py-10">
                        <span className="font-mono text-sm text-terra md:col-span-1">{p.number}</span>
                        <h3 className="font-serif text-xl font-medium leading-snug text-ink md:col-span-4">
                            {p.title}
                        </h3>
                        <div className="md:col-span-7">
                            <p className="text-sm font-light leading-relaxed text-mute sm:text-base">{p.text}</p>
                            {p.points.length > 0 && (
                                <ul className="mt-4 flex flex-wrap gap-x-8 gap-y-2">
                                    {p.points.map((pt) => (
                                        <li key={pt} className="flex items-center gap-3 text-xs uppercase tracking-[0.15em] text-wood">
                                            <span className="h-1 w-1 rotate-45 bg-gold" />
                                            {pt}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                </Reveal>
            ))}
        </div>
    </Chapter>
);
